/* eslint-disable indent,linebreak-style,max-len */
/**
 * Created by charnjeetelectrovese@gmail.com on 9/20/2017.
 */
// import { browserHistory } from 'react-router';
import { setAuthorizationToken } from "../libs/set_auth_token.utils";
import historyUtils from "../libs/history.utils";
import { serviceGetProfile, serviceLogoutUser } from "../services/index.services";
import { connectToSocket, disconnectSocket } from "../libs/SocketUtils";

export const AUTH_USER = "AUTH_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_PROFILE = "SET_PROFILE";
export const GET_PROFILE_INIT = "GET_PROFILE_INIT";

export function actionLoginUser(data) {
  return (dispatch) => {
    if (data) {
      const token = data.token;
      localStorage.setItem("jwt_token", token);
      localStorage.setItem("user", JSON.stringify(data));
      connectToSocket(data.token, data.id);
      setAuthorizationToken(token);
      dispatch({
        type: AUTH_USER,
        payload: { token: token, name: data.name, id: data.user_id, ...data },
      });
        historyUtils.push(`/`);
    }
  };
}

// export function actionLogoutUser() {
//   return (dispatch) => {
//     localStorage.removeItem("jwt_token");
//     localStorage.removeItem("user");
//     setAuthorizationToken(false);
//     dispatch({ type: LOGOUT_USER });
//     historyUtils.push(`/login`);
//     // browserHistory.push(`${process.env.PUBLIC_URL}/login`);
//   };
// }

export function actionLogoutUser() {
    return (dispatch) => {
        if (localStorage.getItem('jwt_token')) {
            serviceLogoutUser({

            });
        }
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('user');
        setAuthorizationToken(false);
        dispatch({ type: LOGOUT_USER });
        setTimeout(() => {
            historyUtils.push(`/login`);
        }, 200);
         disconnectSocket()
        // browserHistory.push(`${process.env.PUBLIC_URL}/login`);
    };
}

export function actionGetProfile() {
  const request = serviceGetProfile();
  return (dispatch) => {
    dispatch({ type: GET_PROFILE_INIT, payload: null });
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: SET_PROFILE, payload: data.data });
      }
    });
  };
}
